import { useContext } from 'react';
import { SignalRContext } from './SignalRContextProvider';



export const useSignalR = () => useContext(SignalRContext);